import React, {useState} from "react";
import {Button, Card, Col, Form, Row} from "react-bootstrap";
import {useHistory} from 'react-router-dom'
import {Country} from "../Pages/Reports/ReportTypes";
import BackBtn from "../BackBtn";

interface Props {
    element: Country,
    saveData: (name: string,
               code: string,
               fvsCode: string,
    ) => void,
}

export default function CountryForm(props: Props) {
    const history = useHistory();

    const {element, saveData} = props;
    const [name, setName] = useState(element.name);
    const [code, setCode] = useState(element.code);
    const [fvsCode, setFvsCode] = useState(element.fvsCode);

    const goBack = () => {
        history.goBack();
    }

    return (
        <Card>
            <Card.Header>
                <BackBtn/>
                Šalis
            </Card.Header>
            <Card.Body>
                <Form>
                    <Form.Group>
                        <Form.Label>Pavadinimas</Form.Label>
                        <Form.Control value={name} onChange={e => setName(e.target.value)}/>
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>Kodas</Form.Label>
                        <Form.Control value={code} onChange={e => setCode(e.target.value)}/>
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>Finvaldos kodas</Form.Label>
                        <Form.Control value={fvsCode} onChange={e => setFvsCode(e.target.value)}/>
                    </Form.Group>

                </Form>
            </Card.Body>
            <Card.Footer>
                <Row>
                    <Col>

                    </Col>
                    <Col className={"text-right"}>
                        <Button type={"button"} variant={"primary"}
                                onClick={() => saveData(
                                    name,
                                    code,
                                    fvsCode,
                                )}>Išsaugoti</Button>
                    </Col>
                </Row>
            </Card.Footer>
        </Card>)
}
